import React from 'react';
import RowButton from './RowButton';
import { useLocale } from './../special/LanguageProvider';


const RowAddButton = ( { onClick = null }) => {
  const {t} = useLocale();
  return (
      <RowButton tooltip={t("Bæta við")} iconclass={"icon-plus-circle no-text"} onClick={onClick} />
  );
}


export default RowAddButton;
